import awaitWrap from './await-wrap.js';

export default async (
  {
    $vs,
    title,
    text,
    action,
    color = 'primary',
    acceptText = 'Zapisz',
    cancelText = 'Wróć',
  },
) => {
  $vs.dialog({
    accept: async () => await awaitWrap(action)(),
    type: 'confirm',
    color,
    title,
    text,
    acceptText,
    cancelText,
  });
};
